import { Member } from '../Avatar';

export type ProjectSearchUser = Member & { id: number };

export const filterProjectSearchUsers = (
  users: ProjectSearchUser[],
  query: string
) => {
  const normalizedQuery = query.trim().toLocaleLowerCase();
  const visibleUsers = normalizedQuery
    ? users.filter(
        user =>
          user.name.toLocaleLowerCase().includes(normalizedQuery) ||
          (user.email || '').toLocaleLowerCase().includes(normalizedQuery)
      )
    : [...users];

  return visibleUsers.sort((firstUser, secondUser) =>
    firstUser.name
      .toLocaleLowerCase()
      .localeCompare(secondUser.name.toLocaleLowerCase())
  );
};
